import { useUserStore } from '@/stores/user'
import type { RouteLocation, RouteLocationRaw } from 'vue-router'

/**
 * Middleware to check if the user is logged out and if so, send them home
 * with the sign-up modal auto-opened instead of a dedicated login page.
 * AppHeader's AppRegisterSignInModal has `check-on-load`, which auto-opens
 * in "register" mode when a `register` query param is present.
 *
 * @param {RouteLocation} to
 * @returns {RouteLocationRaw | boolean}
 */
export default function AuthMiddleware(
  to: RouteLocation
): RouteLocationRaw | boolean {
  const userStore = useUserStore()

  // reject the navigation
  if (userStore.isLoggedOut && to.name !== 'home') {
    return {
      name: 'home',
      query: { register: '' },
    }
  }

  return true
}
